import { FETCH_TEHCATS, FETCH_TEHCAT, FETCH_TEHS, FETCH_TEH } from '../actions/types';

const initialState = {
    tehcats: [],
    tehcat: {},
    tehs: [],
    teh: {}
}

function tehReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_TEHCATS:
            return {
                ...state,
                tehcats: action.payload
            };
        case FETCH_TEHCAT:
            return {
                ...state,
                tehcat: action.payload
            };
        case FETCH_TEHS:
            return {
                ...state,
                tehs: action.payload
            };
        case FETCH_TEH:
            return {
                ...state,
                teh: action.payload
            };
        default:
            return state;
    }
}

export default tehReducer;